import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useLinkLikeClick } from '../../../../hooks'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { ICON_HEIGHT_24 } from '../../../Icon'
import Text from '../../../Text'
import { EpostStatusTimelineContentContainer } from '../EpostStatusTimelineContentContainer'

import { EPOST_TIMELINE_TRACKING_ID_POST_SERVICE_CLICK_EVENT_ARGS } from './EpostStatusTimelineTrackingId.constants'
import { useEpostStatusTimelineTrackingIdCopy } from './EpostStatusTimelineTrackingId.hooks'

import * as styles from './EpostStatusTimelineTrackingId.module.css'

import CopyIcon from '../../../../icons/copy.svg'
import OpenInNewWindowIcon from '../../../../icons/open-in-new-window.svg'

function EpostStatusTimelineTrackingId({ trackingId }) {
  const { t } = useTranslation()

  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const { copied, handleCopyId } = useEpostStatusTimelineTrackingIdCopy({
    trackingId,
  })

  function handleOpenLink(event) {
    handleClick({
      ...EPOST_TIMELINE_TRACKING_ID_POST_SERVICE_CLICK_EVENT_ARGS,
      event,
    })
  }

  function handleMouseDownOpenLink(event) {
    handleMouseDown({
      ...EPOST_TIMELINE_TRACKING_ID_POST_SERVICE_CLICK_EVENT_ARGS,
      event,
    })
  }

  return trackingId ? (
    <EpostStatusTimelineContentContainer titleKey='EpostStatusTimeline.TrackingIdTitleKey'>
      <Text className={styles.text}>{trackingId}</Text>

      <Button.Outlined
        isGrey
        beforeIconProps={{ Icon: CopyIcon }}
        disabled={copied}
        height={BUTTON_HEIGHT_32}
        tooltip={
          copied
            ? t('EpostStatusTimeline.TrackingIdCopiedTooltipKey')
            : t('EpostStatusTimeline.TrackingIdCopyTooltipKey')
        }
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={handleCopyId}
      />

      <Button.Outlined
        isGrey
        beforeIconProps={{ Icon: OpenInNewWindowIcon, height: ICON_HEIGHT_24 }}
        height={BUTTON_HEIGHT_32}
        text={t('EpostStatusTimeline.TrackingIdOpenOutsideBtnTextKey')}
        tooltip={t('Epost.TrackingIdOpenOutsideTooltipKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={handleOpenLink}
        onMouseDown={handleMouseDownOpenLink}
      />
    </EpostStatusTimelineContentContainer>
  ) : null
}

export default EpostStatusTimelineTrackingId
